/* global google:true */
var youbora = require('youboralib')
var manifest = require('../../manifest.json')

var ImaAdsAdapter = youbora.Adapter.extend({
  getVersion: function () {
    return manifest.version + '-videojs-ima-ads'
  },

  getDuration: function () {
    if (this.player.ima.getAdsManager() && this.player.ima.getAdsManager().getCurrentAd() !== null) {
      this.duration = this.player.ima.getAdsManager().getCurrentAd().getDuration()
    }
    return this.duration
  },

  // NOT AVAILABLE AT adStart
  getResource: function () {
    var ret = null
    var manager = this.player.ima.getAdsManager()
    if (manager) {
      ret = manager.getCurrentAd().getMediaUrl()
    }
    return ret
  },

  getTitle: function () {
    var ret = null
    var manager = this.player.ima.getAdsManager()
    if (manager) {
      ret = manager.getCurrentAd().getTitle()
    }
    return ret
  },

  getPlayhead: function () {
    var ret = null
    var manager = this.player.ima.getAdsManager()
    if (manager) {
      ret = this.getDuration() - manager.getRemainingTime()
    }
    return ret
  },

  getPlayerVersion: function () {
    return 'IMA' + google.ima.VERSION + '; contrib-ads ' + this.player.ads.VERSION
  },

  getPosition: function () {
    var ret = youbora.Constants.AdPosition.Preroll
    if (this.plugin._adapter.getDuration() - 1 < this.plugin._adapter.getPlayhead()) {
      ret = youbora.Constants.AdPosition.Postroll
    } else if (this.plugin._adapter.flags.isJoined) {
      ret = youbora.Constants.AdPosition.Midroll
    }
    return ret
  },

  getGivenBreaks: function () {
    var ret = null
    if (this.cuepoints) {
      ret = this.cuepoints.length
    }
    return ret
  },

  getBreaksTime: function () {
    return this.cuepoints
  },

  getGivenAds: function () {
    return this.totalAds
  },

  getAudioEnabled: function () {
    return !this.player.ima.adMuted
  },

  getIsSkippable: function () {
    return this.isSkippable
  },

  getIsFullscreen: function () {
    var ret = false
    var container = this.player.ima.adDisplayContainer
    for (var index in container) {
      if (container[index] && container[index].width && container[index].height) {
        if (window.innerHeight && window.innerWidth && container[index].width && container[index].height) {
          ret = (window.innerHeight <= container[index].height + 30 && window.innerWidth <= container[index].width + 30)
        }
      }
    }
    return ret
  },

  getIsVisible: function () {
    return youbora.Util.calculateAdViewability(this.player.ima.adContainerDiv)
  },

  registerListeners: function () {
    // Enable playhead monitor
    this.monitorPlayhead(true, false)

    // Shortcut events
    var event = google.ima.AdEvent.Type

    // Register listeners
    this.references = {}
    this.references[event.AD_METADATA] = this.metadataListener.bind(this)
    this.references[event.LOADED] = this.loadedListener.bind(this)
    this.references[event.CONTENT_PAUSE_REQUESTED] =
      this.contentPauseRequestedListener.bind(this)
    this.references[event.STARTED] = this.startedListener.bind(this)
    this.references[event.PAUSED] = this.pausedListener.bind(this)
    this.references[event.RESUMED] = this.resumedListener.bind(this)
    this.references[event.COMPLETE] = this.completeListener.bind(this)
    this.references[event.SKIPPED] = this.skippedListener.bind(this)
    this.references[event.CLICK] = this.clickListener.bind(this)
    this.references[google.ima.AdErrorEvent.Type.AD_ERROR] =
      this.errorListener.bind(this)
    this.references[event.ALL_ADS_COMPLETED] = this.adsEndedListener.bind(this)
    this.references[event.FIRST_QUARTILE] = this.firstQuartileListener.bind(this)
    this.references[event.MIDPOINT] = this.secondQuartileListener.bind(this)
    this.references[event.THIRD_QUARTILE] = this.thirdQuartileListener.bind(this)

    this.playerReferences = {
      'adend': this.adEndedListener.bind(this),
      'adstart': this.startedListener.bind(this),
      'adskip': this.skippedListener.bind(this),
      'adserror': this.errorListener.bind(this),
      'ads-click': this.clickListener.bind(this)
    }

    if (this.player && this.player.ima) {
      Object.keys(this.references).forEach(function (key) {
        this.player.ima.addEventListener(key, this.references[key])
      }.bind(this))
      Object.keys(this.playerReferences).forEach(function (key) {
        this.player.on(key, this.playerReferences[key])
      }.bind(this))
    }
  },

  metadataListener: function (e) {
    this.cuepoints = e.getAdCuePoints().h.slice()
    if (this.plugin._adapter) {
      this.cuepoints.forEach(function (value, index) {
        if (this.cuepoints[index] === -1 || this.cuepoints[index] == null || this.cuepoints[index] === undefined) {
          this.cuepoints[index] = this.plugin._adapter.getDuration()
        }
      }.bind(this))
    }
  },

  loadedListener: function (e) {
    this.isSkippable = e.getAdData().skippable
    this.totalAds = e.getAdData().adPodInfo.totalAds
    this.fireStart()
  },

  contentPauseRequestedListener: function (e) {
    this.fireStart()
  },

  startedListener: function (e) {
    this.fireStart()
    this.fireJoin()
  },

  pausedListener: function (e) {
    this.firePause()
  },

  resumedListener: function (e) {
    this.fireResume()
  },

  completeListener: function (e) {
    this.fireStop()
  },

  skippedListener: function (e) {
    this.fireSkip()
  },

  adEndedListener: function (e) {
    this.fireStop()
  },

  errorListener: function (e) {
    var error = e.getError()
    this.fireError(error.getCode(), error.getMessage())
  },

  clickListener: function (e) {
    this.fireClick()
  },

  adsEndedListener: function (e) {
    this.plugin.getAdapter().adsEnded = true
    this.fireStop()
    if (this.plugin.requestBuilder.lastSent.adPosition === youbora.Constants.AdPosition.Postroll) {
      this.plugin.fireStop()
    }
  },

  firstQuartileListener: function (e) {
    this.fireQuartile(1)
  },

  secondQuartileListener: function (e) {
    this.fireQuartile(2)
  },

  thirdQuartileListener: function (e) {
    this.fireQuartile(3)
  },

  unregisterListeners: function () {
    // Disable playhead monitoring
    if (this.monitor) this.monitor.stop()

    // unregister listeners
    if (this.player && this.player.ima && this.references && this.playerReferences) {
      Object.keys(this.references).forEach(function (key) {
        this.player.ima.removeEventListener(key, this.references[key])
      }.bind(this))
      Object.keys(this.playerReferences).forEach(function (key) {
        this.player.off(key, this.playerReferences[key])
      }.bind(this))
    }
    delete this.references
    delete this.playerReferences
  }
},
// Static Members
{
  isUsed: function (plugin) {
    return plugin.player.ima
  }
}
)

module.exports = ImaAdsAdapter
